import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./redux/configureStore";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/Auth.context";
import { CanvasProvider } from "./context/CanvasContext";

const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <AuthProvider>
      <CanvasProvider>
        <Router>
          <App />
        </Router>
        </CanvasProvider>
      </AuthProvider>
      ,
    </ReduxProvider>
    ,
  </React.StrictMode>,
  document.getElementById("app")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
